import { render, staticRenderFns } from "./PostParams.vue?vue&type=template&id=6fa931d8"
import script from "./PostParams.vue?vue&type=script&lang=js"
export * from "./PostParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports